import {
  PublishContent,
  PublishFonts,
  PublishPresets,
} from '@/store_old/reducers/publish'

const PRESET_LIST = [
  {
    bgColor: '#FFFFFF',
    name: PublishPresets.DEFAULT,
    font: PublishFonts.DEFAULT,
    content: PublishContent.TRANSPARENT,
  },
  {
    bgColor: '#F3F7FB',
    name: PublishPresets.BLUEPRINT,
    font: PublishFonts.DEFAULT,
    content: PublishContent.TRANSPARENT,
  },
  {
    bgColor: '#2B3C56',
    name: PublishPresets.DARK,
    font: PublishFonts.DEFAULT,
    content: PublishContent.TRANSPARENT,
  },
  {
    bgColor: '#2F7FEF',
    name: PublishPresets.BLUE,
    font: PublishFonts.DEFAULT,
    content: PublishContent.SHEET,
  },
  {
    bgColor: '#DAD6CE',
    name: PublishPresets.SANDSTONE,
    font: PublishFonts.MONO,
    content: PublishContent.SHEET,
  },
  {
    bgColor: '#557177',
    name: PublishPresets.SLATE_GREEN,
    font: PublishFonts.SERIF,
    content: PublishContent.ISLANDS,
  },
]

export const PRESETS = Object.fromEntries(
  PRESET_LIST.map((preset) => [preset.name, preset])
)

export const FONTS = [
  PublishFonts.DEFAULT,
  PublishFonts.SERIF,
  PublishFonts.MONO,
]

export const CONTENTS = [
  PublishContent.TRANSPARENT,
  PublishContent.SHEET,
  PublishContent.ISLANDS,
]
